/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Bills_List_Empty_TitleInputs */

const es_admin_billing_bills_list_empty_title = /** @type {(inputs: Admin_Billing_Bills_List_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin facturas`)
};

const en_admin_billing_bills_list_empty_title = /** @type {(inputs: Admin_Billing_Bills_List_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No invoices`)
};

/**
* | output |
* | --- |
* | "No invoices" |
*
* @param {Admin_Billing_Bills_List_Empty_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_bills_list_empty_title = /** @type {((inputs?: Admin_Billing_Bills_List_Empty_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Bills_List_Empty_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_bills_list_empty_title(inputs)
	return en_admin_billing_bills_list_empty_title(inputs)
});
export { admin_billing_bills_list_empty_title as "admin.billing.bills_list.empty_title" }